import { useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import _ from 'lodash'
import HelperString from 'utils/helper-string'
import React, { useMemo, useRef, useState } from 'react'
import { useNavigation, useRoute } from '@react-navigation/native'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import { constantsActive } from 'utils/constants/constants'
import { LocationTypes } from 'utils/constants/location-types';
import { Image, StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { dataConstants } from 'services/redux/data/constants'
import { localeSettingConstants } from 'utils/constants/LocaleSettings'
import HelperAnimation from 'utils/helper/HelperAnimation'
import HelperLocaleSettings from 'utils/helper/HelperLocaleSettings'
import fakeBuilding from 'assets/images/fake/building.jpg'
import fakeFloor from 'assets/images/fake/floor.jpg'
import fakeRoom from 'assets/images/fake/room.jpeg'
import HelperTestID from 'utils/HelperTestID'
import { TESTID } from '_shared/config/testID'
import Translate from 'utils/translate'
import i18n from 'utils/i18n'
import DataItem from 'components/atoms/DataItem'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import Text from "theme/Text";
import HelperArray from 'utils/helper-array'
import ThemedItem from 'components/atoms/ThemedItem'
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import ThemedPressable from 'components/atoms/ThemedPressable'
import * as Animatable from 'react-native-animatable'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperCart from 'utils/helper-cart'
import { getNextLocationRoute } from 'scenes/home/book/_functions/RouteHelpers'
import selectTimeslotGroup from 'services/redux/data/selectors/selectTimeslotGroup'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { dateFormat } from 'utils/helper-date'

const Location = ({ location, locationType, building, floor, timeslotKindsForGroup, favourite = false, index = -1 }) => {
	
	const route = useRoute();
	const navigation = useNavigation();
	const refHeart = useRef( null );
	const _routeParameters = useRouteParameters( route );
	
	const _timeslotGroup = useSelector( state => {
		return selectTimeslotGroup(state, _.get(_routeParameters, routeBookingConstants.TIMESLOT_GROUP));
	} ); // do not remove, required for reloading
	const _bookDate = useSelector( state => {
		return state.cart[cartConstants.BOOK_DATE];
	} );
	const _capacities = useSelector( state => {
		return state.cart[cartConstants.CAPACITIES];
	} );
	const _buildingFavourites = useSelector( state => {
		return state.data[dataConstants.BUILDING_FAVOURITES];
	} );
	const _floorFavourites = useSelector( state => {
		return state.data[dataConstants.FLOOR_FAVOURITES];
	} );
	const _roomFavourites = useSelector( state => {
		return state.data[dataConstants.ROOM_FAVOURITES];
	} );
	const _bookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_COWORKERS];
	} );
	const _cartBookingCoworkers = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	
	const [ isFavourite, setIsFavourite ] = useState( favourite );
	
	// Default amount = 1 plus the extra selected
	const bookForMyself = HelperCart.bookingForMyself( _bookForOption );
	const personAmount = ( ( bookForMyself ? 1 : 0 ) + _.size( _bookingExternalPersons ) + _.size( _cartBookingCoworkers ));
	
	const showCapacity = _.get( _timeslotGroup, 'showCapacity', constantsActive.YES ) === constantsActive.YES;
	
	const capacity = useMemo( () => {
		const capacity = {
			[ locationType ] : _.get( _capacities, [ 'capacities', locationType, location.guid, _bookDate.format( dateFormat.DATE ) ], {} )
		};
		
		switch( locationType ) {
			case LocationTypes.ROOMS:
				capacity[ LocationTypes.FLOORS ] = _.get( _capacities, [ 'capacities', LocationTypes.FLOORS, building.guid, _bookDate.format( dateFormat.DATE ) ], {} );
			// Yes no break ;-)
			case LocationTypes.FLOORS:
				capacity[ LocationTypes.BUILDINGS ] = _.get( _capacities, [ 'capacities', LocationTypes.BUILDINGS, building.guid, _bookDate.format( dateFormat.DATE ) ], {} );
				break;
		}
		
		return capacity;
	}, [ locationType, _capacities, location, _bookDate ] )
	
	const itemPressed = () => {
		let routeParameters = {..._routeParameters}
		routeParameters[ routeBookingConstants.DEPTH_LEVEL ] = _.get( routeParameters, routeBookingConstants.DEPTH_LEVEL, routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].BUILDING );
		
		let nextRoute = getNextLocationRoute( routeParameters, location, locationType );

		navigation.navigate( nextRoute.routeLocation, nextRoute.routeParams );
	}
	
	const updateIsFavourite = () => {
		const newFavouriteState = !isFavourite;
		setIsFavourite( newFavouriteState );
		
		let favourites = {};
		let settingsIdentifier = null;
		
		switch( locationType ) {
			case LocationTypes.ROOMS:
				favourites = _roomFavourites;
				settingsIdentifier = localeSettingConstants.ROOM_FAVOURITES;
				break;
			
			case LocationTypes.FLOORS:
				favourites = _floorFavourites;
				settingsIdentifier = localeSettingConstants.FLOOR_FAVOURITES;
				break;
			
			case LocationTypes.BUILDINGS:
				favourites = _buildingFavourites;
				settingsIdentifier = localeSettingConstants.BUILDING_FAVOURITES;
				break;
		}
		
		if( !newFavouriteState ){
			delete favourites[ location.guid ];
		}else{
			favourites[ location.guid ] = true;
			HelperAnimation.pulse( refHeart );
		}
		
		HelperLocaleSettings.set( settingsIdentifier, favourites );
	}
	
	const backgroundImage = useMemo( () => {
		const backgroundImage = _.get( location, 'photo_url', null );
		if( backgroundImage === null ) {
			switch( locationType ) {
				case LocationTypes.BUILDINGS:
					return fakeBuilding;
				
				case LocationTypes.FLOORS:
					return fakeFloor;
				
				case LocationTypes.ROOMS:
					return fakeRoom;
			}
			
			return null;
		}
		
		return { uri: backgroundImage };
	}, [ locationType, location ] )
	
	const testID = HelperTestID.generate( TESTID.HOME.BOOK.LOCATION.LOCATION_ITEM, [ index ] );
	let title =  Translate.field( location, 'title' );
	let dataItems = [];
	
	let available = true;
	let itemPressedEnabled = true;
	
	// Get the location types for this specific capacity
	const locationTypesForCapacity = useMemo( () => {
		const result = [];
		
		switch( locationType ){
			case LocationTypes.ROOMS:
				result.push( LocationTypes.ROOMS );
				break;
			
			// yes no break
			case LocationTypes.FLOORS:
				result.push( LocationTypes.FLOORS );
				break;
			
			// yes no break
			case LocationTypes.BUILDINGS:
				result.push( LocationTypes.BUILDINGS );
				break;
		}
		
		return result;
	}, [ locationType ] );
	
	if( showCapacity ) {
		let hasAvailableCapacity = false;
		let hasTimeslotWithCapacity = false;
		
		_.forEach( timeslotKindsForGroup, ( timeslotKind ) => {
			if( timeslotKind.show_capacity === constantsActive.YES ) {
				_.forEach( locationTypesForCapacity, ( locationTypeForCapacity ) => {
					const identifier = `${ timeslotKind?.kind }_${ timeslotKind?.sub_kind }`;
					const timeslotCapacity = _.get( capacity, [ locationTypeForCapacity, identifier ], null );
					
					// When there is no timeslot capacity found, then we should not render it.
					if( timeslotCapacity === null ) {
						return true;
					}
					
					const capacityTotal = _.get( timeslotCapacity, [ 'capacity' ], -1 );
					const capacityRemaining = _.get( timeslotCapacity, [ 'remaining' ], '...' );
					
					if( capacityTotal === 0 && capacityRemaining === 0 && locationTypesForCapacity.indexOf( locationTypeForCapacity ) < 1 ) {
						return true;
					}
					
					let capacity_text = i18n.t( 'constants.capacity_remaining.booking', {
						capacity_total: capacityTotal,
						capacity_remaining: capacityRemaining
					});
					
					hasTimeslotWithCapacity = true;
					
					switch( true ) {
						case capacityTotal === -1 && capacityRemaining !== '...':
							capacity_text = i18n.t( 'constants.not_available.booking' );
							break;
						
						case capacityRemaining !== '...' && parseInt( capacityRemaining ) === 0:
							capacity_text = i18n.t( 'constants.not_available.booking' );
							break;
						
						case capacityRemaining !== '...' && parseInt( capacityRemaining ) < personAmount:
							capacity_text = i18n.t( 'constants.insufficient_capacity_remaining.booking', {
								capacity_remaining: capacityRemaining,
								required_amount: personAmount
							} );
							break;
							
						default:
							hasAvailableCapacity = true;
					}
					
					dataItems.push(
						<DataItem
							key={ HelperString.hash( 'workplaces_count', timeslotKind ) }
							identifier={ 'workplaces_count' }
							icon={ <Icon icon={ timeslotKind.icon } {...{ style: [ DataItemStyles.headerIcon ] }} /> }
							content={ capacity_text }
							testID={ `${testID}_workplaces_count` }>
							
							{ Translate.field( timeslotKind, 'count', 'name', null, 'title') }
						</DataItem>
					);
					
					return false;
				});
			}
		});
		
		if( hasTimeslotWithCapacity && hasAvailableCapacity === false  ){
			itemPressedEnabled = false;
			available = false;
		}
	}
	
	// Get the favourites for only this  item!
	// Uses the same logic as the capacity
	const favourites = [];
	_.forEach( timeslotKindsForGroup, ( timeslotKind ) => {
		_.forEach( locationTypesForCapacity, ( locationTypeForCapacity ) => {
			const identifier = `${ timeslotKind?.kind }_${ timeslotKind?.sub_kind }`;
			const timeslotCapacity = _.get( capacity, [ locationTypeForCapacity, identifier ], null );
			
			// Get all the favourites from the timeslot capacity
			const capacityFavourites = _.get( timeslotCapacity, [ 'favourites' ], '' );
			
			// Now create an array with the favourites, but remove the empty values
			if( !HelperString.isEmptyString( capacityFavourites ) ) {
				const capacityFavouritesList = _.filter( capacityFavourites.split('|||'), o => {
					return !HelperString.isEmptyString(o);
				} );
				if ( !_.isEmpty( capacityFavouritesList ) ) {
					_.forEach( capacityFavouritesList, ( capacity_favourite ) => {
						if( _.includes( favourites, capacity_favourite ) === false ) {
							favourites.push( capacity_favourite );
						}
					} );
				}
			}
		})
	})
	
	if ( _.size( favourites ) > 0 ) {
		// Sort the favourites alphabetically
		const sortedFavourites = favourites.sort();
		
		dataItems.push(
			<DataItem
				key={ HelperString.hash('coworkers', HelperString.random() ) }
				icon={ <Icon icon={ IconSystemConstants.PERSONS } style={ [ DataItemStyles.headerIcon ] } checked={true} /> }
				identifier={ 'coworkers' }
				content={(
					<Text
						key={ HelperString.hash('coworker-favourites') }
						style={ DataItemStyles.text }>
						
						{ HelperArray.naturalJoin( sortedFavourites ) }
					</Text>
				)}>
				
				{ i18n.t( 'constants.coworkers_booked' ) }
			</DataItem>
		);
	}
	
	if ( Translate.field( location, 'description', null ) !== null ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('information') }
				identifier={ 'information' }
				icon={ <Icon icon={ IconSystemConstants.INFO } style={ [ DataItemStyles.headerIcon ] } /> }
				content={ Translate.field( location, 'description' ) }>
				
				{ i18n.t( 'constants.information' ) }
			</DataItem>
		);
	}
	
	let locationItem = (
		<ThemedItem
			accessoryLeft={ <Image source={ backgroundImage } style={ ThemedItemStyles.accessoryLeft } />}
			title={ title }
			items={ dataItems }
			actionItem={
				<ThemedPressable onPress={ updateIsFavourite } hitSlop={ 10 }>
					<Animatable.View ref={ refHeart }>
						<Icon icon={ IconSystemConstants.FAVOURITE } checked={ isFavourite } style={ [ styles.heart ] } />
					</Animatable.View>
				</ThemedPressable>
			}
		/>
	);
	
	const themedBlockStyles = [];
	
	if( available ) {
		locationItem = (
			<ThemedPressable
				onPress={ itemPressedEnabled ? itemPressed : null }
				testID={ testID }>
				
				{ locationItem }
			</ThemedPressable>
		);
	} else {
		themedBlockStyles.push( styles.themedBlockDisabled );
	}
	
	return (
		<ThemedBlock
			key={ HelperString.hash( 'item-block', location )}
			style={ themedBlockStyles }
			shadow>
			
			{ locationItem }
		</ThemedBlock>
	);
}

const styles = StyleSheet.create({
	themedBlockDisabled: {
		opacity: 0.3
	},
	heart: {
		color: colorList.ORANGE.primary,
		fontSize: 18
	},
});

export default Location
